var _title, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "-5 0 30 17",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Menu")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Colour-/-White",
  transform: "rotate(90 10 10)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h2v20H0z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 8v2H0V8zM20 15v2H0v-2z"
})));
export default SvgMenu;